exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".subscribed{text-align:center}.subscribed .error{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/subscribed.scss
// module id = 1321
// module chunks = 2